import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Row, Col, Modal, ModalBody, ModalHeader, ModalFooter, Button, Pagination, PaginationItem, PaginationLink } from "reactstrap";
import { OutputRow, BoldLabel, EditIcon, PinkButtonContainer } from "../../../utils/budget-tool-specific";
import { RebelColors, RebelCard, RebelButton, RebelSecondaryButton, RebelDangerButton } from "../../../styles/rebel-experiences";
import { GetDB, generateGUID } from "../../../utils/database/firebase-budget-tool";
import { listenToCollection, setDocument, updateDocumentProperty, deleteDocument } from "../../../utils/firestore-functions";
import firebase from "firebase/compat/app";

const RebelExperienceGuideList = () => {

    const [guideList, setGuideList] = useState({});
    const [sortedList, setSortedList] = useState({});
    const [deleteID, setDeleteID] = useState("");

    const budgetDB = GetDB();

    const [currentPage, setCurrentPage] = useState(0);
    const [recordsPerPage] = useState(15);

    const nPages = Math.ceil(Object.entries(sortedList).length / recordsPerPage);


    useEffect (() =>{
        var unsubscribe = listenToCollection(budgetDB, "rebelExperienceGuides", SetLists);
        return unsubscribe;
    }, [])

    const SetLists = (guides) => {

        let x = guides.reduce((accumulator, value) => {
            return {...accumulator,  [value.id]: value}
        }, {});
        setGuideList(x);
        setSortedList(Object.fromEntries(Object.entries(x).sort(function(a, b){
            return b[1].lastModification - a[1].lastModification;
        })));

        Object.entries(x).sort(function(a, b){
            return b[1].lastModification - a[1].lastModification;
        }).slice(1,9);


    }

    const openGuide = (id) => {
        const timeStamp = firebase.firestore.Timestamp.now().toDate();
        updateDocumentProperty(budgetDB, "rebelExperienceGuides", id, "lastModification", timeStamp);
        window.location = "/budget-app/rebel-experiences/edit/" + id;
    }

    const createNewGuide = () => {

        const newTitle = "R.E.B.E.L Experience Guide " + (Object.keys(guideList).length +  1);
        const timeStamp = firebase.firestore.Timestamp.now().toDate();

        let newExperience = {
            title: newTitle,
            location: "",
            lastModification: timeStamp,
            id: generateGUID(),
            experiences: {},
            attendees: 8,
            occupancy: "Single Occupancy",
            tripLength: 2,
            currency: "USD$",
            contingency: 5,
            overhead: 5,
            overheadPercent: true,
            margin: 250,
            marginPercent: false,
            version: "Version 1.0"
        }

        const openNewGuide = () => {
            openGuide(newExperience.id);
        }

        setDocument(budgetDB, "rebelExperienceGuides", newExperience.id, newExperience, openNewGuide);

    }
    const deleteGuide = async (id) => {
        toggleDeleteModal();
        console.log("deleting " + deleteID );
        deleteDocument(budgetDB, "rebelExperienceGuides", deleteID);
    }

    const confirmDelete = (id) => {
        toggleDeleteModal();
        setDeleteID(id);
    }

    const [modal, setModal] = useState(false);

    const toggleDeleteModal = () => setModal(!modal);

    const navigateToPage = (e, i) => {
        setCurrentPage(i);
    }

    return (

        <React.Fragment>
            <RebelModal isOpen={modal} toggle={toggleDeleteModal}>
                <RebelModalHeader toggle={toggleDeleteModal}>Are you sure you would like to delete this R.E.B.E.L guide?</RebelModalHeader>
                <RebelModalBody>
                Once you've deleted this R.E.B.E.L guide, you will not be able to access it again. All guide data will be lost.
                </RebelModalBody>
                <RebelModalFooter>
                <RebelSecondaryButton onClick={toggleDeleteModal}>
                    Cancel
                </RebelSecondaryButton>
                <RebelDangerButton onClick={x => deleteGuide(deleteID)} >
                    Delete R.E.B.E.L Guide
                </RebelDangerButton>
                </RebelModalFooter>
            </RebelModal>
            <Row>
                <Col>
                    <RebelCard style={{marginRight: "15px", marginLeft: "15px"}}>
                        <RebelOutputRow>
                            <Col>
                                <RebelBoldLabel>
                                    Title
                                </RebelBoldLabel>
                            </Col>
                            <Col>
                                <RebelBoldLabel>
                                    Date modified
                                </RebelBoldLabel>
                            </Col>
                            <Col style={{textAlign: "right"}}>
                                <RebelButton style={{marginBottom: "16px", marginTop: "-6px"}} onClick={createNewGuide}>Create New R.E.B.E.L Guide</RebelButton>
                            </Col>
                        </RebelOutputRow>
                        {sortedList !== undefined && Object.entries(sortedList).slice(currentPage * recordsPerPage,
                        (currentPage + 1) * recordsPerPage).map((guide, i) => {

                            return (
                                <React.Fragment>
                                    <RebelOutputRow key={i}>
                                        <Col>
                                            <RebelText>{guide[1].title}</RebelText>
                                        </Col>
                                        <Col>
                                            <RebelText>{(guide[1].lastModification !== undefined && guide[1].lastModification !== "") ?
                                                            guide[1].lastModification.toDate().toLocaleString("en-US") :
                                                            ""}</RebelText>
                                        </Col>
                                        <Col style={{textAlign: "right", paddingRight: "30px"}}>
                                            <RebelIconButton onClick={(x) => openGuide(guide[1].id)}>
                                                <RebelEditIcon icon={['fas', 'pen']} style={{height: "25px", paddingLeft: "2px"}}/>
                                            </RebelIconButton>
                                            <RebelIconButton onClick={(x) => confirmDelete(guide[1].id)}>
                                                <RebelEditIcon icon={['fas', 'trash']} style={{height: "25px"}}/>
                                            </RebelIconButton>
                                        </Col>
                                    </RebelOutputRow>
                                </React.Fragment>
                            ) })
                        }
                        <Row style={{marginTop: "30px"}}>
                            <Col style={{textAlign: "center"}}>
                                <RebelPagination style={{justifyContent: "center"}}>
                                    <RebelPaginationItem disabled={currentPage <= 0}>
                                        <RebelPaginationLink
                                        onClick={e => navigateToPage(e, 0)}
                                        first
                                        href="#"
                                        />
                                    </RebelPaginationItem>
                                    <RebelPaginationItem disabled={currentPage <= 0}>
                                        <RebelPaginationLink

                                        onClick={e => navigateToPage(e, currentPage-1)}
                                        href="#"
                                        previous
                                        />
                                    </RebelPaginationItem>
                                    {[...Array(nPages)].map((page, i) =>
                                    <RebelPaginationItem active={i === currentPage} key={i}>
                                        <RebelPaginationLink  active={i === currentPage} onClick={e => navigateToPage(e, i)} href="#">
                                        {i + 1}
                                        </RebelPaginationLink>
                                    </RebelPaginationItem>
                                    )}

                                    <RebelPaginationItem disabled={currentPage+1 >= nPages}>
                                        <RebelPaginationLink
                                        onClick={e => navigateToPage(e, currentPage+1)}
                                        href="#"
                                        next
                                        />
                                    </RebelPaginationItem>
                                    <RebelPaginationItem disabled={currentPage+1 >= nPages}>
                                        <RebelPaginationLink
                                        onClick={e => navigateToPage(e, nPages-1)}
                                        href="#"
                                        last
                                        />
                                    </RebelPaginationItem>
                                </RebelPagination>
                            </Col>
                        </Row>
                    </RebelCard>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default RebelExperienceGuideList;

const RebelOutputRow = styled(OutputRow)`
    border-bottom: 1px solid ${RebelColors.border};
`;

const RebelBoldLabel = styled(BoldLabel)`
    color: ${RebelColors.gold};
    font-weight: 600;
`;

const RebelText = styled.p`
    color: ${RebelColors.primary};
    margin: 0;
    padding: 4px 0 12px 0;
`;

const RebelIconButton = styled.div`
    display: inline-block;
    margin: 0px 5px;
    width: auto;
    height: auto;
    border-radius: 10px;
    padding: 4px 12px 12px 12px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        background-color: rgba(255, 215, 0, 0.2);
    }

    &:hover svg {
        color: ${RebelColors.gold};
    }
`;

const RebelEditIcon = styled(EditIcon)`
    color: ${RebelColors.gold};
    &:hover {
        color: white;
    }
`;

const RebelPagination = styled(Pagination)`

`;

const RebelPaginationItem = styled(PaginationItem)`
    ${props => props.active && `
        color: white;
        background-color: ${RebelColors.accent};
    `}
`;

const RebelPaginationLink = styled(PaginationLink)`
    background-color: ${RebelColors.surface} !important;
    border-color: ${RebelColors.border} !important;
    color: ${RebelColors.gold} !important;

    &:hover {
        background-color: ${RebelColors.surfaceLight} !important;
        color: ${RebelColors.gold} !important;
        border-color: ${RebelColors.gold} !important;
    }

    ${props => props.active && `
        color: #000000 !important;
        background-color: ${RebelColors.gold} !important;
        border-color: ${RebelColors.gold} !important;
    `}
`;

const RebelModal = styled(Modal)`
    .modal-content {
        background-color: ${RebelColors.surface};
        border: 1px solid ${RebelColors.border};
        color: ${RebelColors.primary};
    }
`;

const RebelModalHeader = styled(ModalHeader)`
    background-color: ${RebelColors.surfaceLight};
    border-bottom: 1px solid ${RebelColors.border};
    color: ${RebelColors.gold};

    .btn-close {
        filter: invert(1);
    }
`;

const RebelModalBody = styled(ModalBody)`
    background-color: ${RebelColors.surface};
    color: ${RebelColors.primary};
`;

const RebelModalFooter = styled(ModalFooter)`
    background-color: ${RebelColors.surfaceLight};
    border-top: 1px solid ${RebelColors.border};
`;